import React, {useMemo} from 'react';
import SPBreadcrumb from 'components/base/SPBreadcrumb';
import SPModuleTitle from "components/base/SPModuleTitle";
import SPTuwen from "components/base/SPTuwen";
import SPTable from "components/actives/take-the-lead/table";
import SPDrawer from "components/actives/take-the-lead/drawer";

interface IPageProps {
	enums?: any;
	permission?: any;
}

const SPPage: React.FC<IPageProps> = props => {
	const { enums, permission } = props;

  const pics = useMemo(() => {
    const list = enums?.f_qiangshoukeng_introduc_pics || []
    return list.map((item: any) => item.value)
  }, [enums])

  const text = useMemo(() => {
    const list = enums?.f_qiangshoukeng_introduc_text || []
    return list.map((item: any) => item.value).join('')
  }, [enums])

	return (
    <>
      <SPBreadcrumb title={'供应商卡片抢首坑'}></SPBreadcrumb>
      <div style={{marginTop: '16px'}}>
        <SPModuleTitle title='产品介绍'></SPModuleTitle>
      </div>
      <SPTuwen pics={pics} text={text}/>
      <div style={{marginTop: '16px'}}>
        <SPModuleTitle title='参与抢首坑'></SPModuleTitle>
      </div>
      <div style={{marginTop: '16px'}}>
        <SPTable permission={permission} enums={enums}></SPTable>
      </div>
      <SPDrawer></SPDrawer>
    </>
  );
};

export default SPPage;
